var map = {
	"./SIMcard.js": "872c",
	"./business.js": "e504",
	"./common.js": "ea93",
	"./home.js": "e870",
	"./income.js": "19bf",
	"./increase.js": "ca4f",
	"./integral.js": "d2e0",
	"./machine.js": "fac9",
	"./message.js": "0bc5",
	"./newBusiness.js": "88a6",
	"./newIncome.js": "5421",
	"./oldApp.js": "14fb",
	"./order.js": "80f7",
	"./ranking.js": "d32c",
	"./refuelPack.js": "bece",
	"./shop.js": "c73d",
	"./storehouse.js": "dd48",
	"./terminalOrder.js": "068f",
	"./training.js": "1fd4",
	"./transfer.js": "a171",
	"./user.js": "7e44",
	"./verified.js": "9ad5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fe63";